
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKkmCUAulRc73sbxEavs7aqeASBo_baMztm1JZ9NRXLEMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/index.vue?macro=true";
import { default as logoutm3uO7ZjPIrYWghciLkRTa5oUYgkYeK_06FMGL75fpr4Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/logout.vue?macro=true";
import { default as _91id_93MZt3jTs_dwKFZDLEIM6QWzql1QS0AeZ35S0VHbGGUNYMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/quiz/[id].vue?macro=true";
import { default as formKu66tJE5Skot_9FFUjzR3PlEWQ_YfEKMz6KDH4P31VYMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/quiz/form.vue?macro=true";
import { default as _91id_93_45qXXhTs8ERNfkKj4yToUzBXsw9Hz9nWH0JKujj3N3PIMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/menus/[id].vue?macro=true";
import { default as formsFPaCpISPzZusfXGMbsXoEOf6bY0UPrNdZ_45DPBDf7N8Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/menus/form.vue?macro=true";
import { default as indexxgNDvgYTtPTctdzVL6uo5XQKSpcvrshtwGFFdtIrVRkMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/quiz/index.vue?macro=true";
import { default as _91id_93lm4pqXnM0mOMB0QQvgnUG7M5faekiUqI_45Rwyj9con_kMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/roles/[id].vue?macro=true";
import { default as formNxivUSytVlNmbLwjyvar1UbyZPhQZxL8j2rxSlpv_45k4Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/roles/form.vue?macro=true";
import { default as _91id_932FnCagwbuELGmo3PTthdF4ulqTKaFk_MTYWtcYIzB5oMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/users/[id].vue?macro=true";
import { default as formE7g5wWJ9PQowdK0vWb3EahKab55dG5pRoXIfwkrSoZ0Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/users/form.vue?macro=true";
import { default as indextLsGFzbgRdqXLwlVUEhWihYedTCGu7Spvg8_Rc71_45uEMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/menus/index.vue?macro=true";
import { default as index_Tf95vUxfCS4h0eTsTj9ZN1UkKtmzaTV01_45iEXK0uLIMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/roles/index.vue?macro=true";
import { default as indexxi8RYSDzZIocmdh_hAAq6g69y1l1EMYuda6hQQ6YoqsMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/users/index.vue?macro=true";
import { default as _91id_930G9mc5jnqiNSVZQJbaKawjbgxIdEcU_450obSvj4v5Q2MMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/ecourse/[id].vue?macro=true";
import { default as formeKLiX34RBSdarFkDeAEiolOrXElu2l7BHp7r0Wv2bgMMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/ecourse/form.vue?macro=true";
import { default as _91id_93BiRZS5tjl74Rs6biplNAk8DMlwQzBbVZJ7R5_ekryWEMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/pembeli/[id].vue?macro=true";
import { default as _91id_93DDmWIwkCRSix_457_g3KHIyWGN4kymHV1kIVynH1rBhu4Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/produks/[id].vue?macro=true";
import { default as form6aWLgeNBo0mupnJ7WraRtIr0ijb6_45F3sZ93bf50gFnIMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/produks/form.vue?macro=true";
import { default as _91id_938IbxxvjqUZe_45ACzwH9kHXT64AriOT_uZLoZ1H9bijUUMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/royalty/[id].vue?macro=true";
import { default as _91id_93T6wIGTuWpVeQc409A_45ZMz8FRrQJUXeWBX65cTrD_cw0Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/student/[id].vue?macro=true";
import { default as _91id_93a6uXrLABA_45vLhSA7lERo8sIdca7E85UmLXaT_45v1cDLMMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/discount/[id].vue?macro=true";
import { default as formvRVgs7cM3t3ooHtSlgYzqGRrGkbYUOQNhq8pv05qJP8Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/discount/form.vue?macro=true";
import { default as indexxIgXTeu2hR9GepvOUduy_45ELO_Kiyc1W6IMPY__q4cBEMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/ecourse/index.vue?macro=true";
import { default as indexkCVrqogDzy3yv_45l_45UYv4_PP_455c51JmplnrXvpyGVzecMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/produks/index.vue?macro=true";
import { default as indexGE3zo_45y5VZjneL6qKXT5IOFOpChbqziPJ4WOiPGsCwgMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/discount/index.vue?macro=true";
import { default as forgotpasswordFyI5tXrgWxHdaZ5PctvBjVGMMZGUXWi0gOMALryUZQEMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/forgotpassword.vue?macro=true";
import { default as _91id_93lGF6CcZQO875Aa8Ir1PMbsHaFzdY1dAKbyIULha8_bAMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/halstatis/[id].vue?macro=true";
import { default as formfJ0BltKWZsISPImeSOubm3rj6aXX1PgDbXCyKVeWJiAMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/halstatis/form.vue?macro=true";
import { default as _91id_93LaaGLmvWKEBDLpHNP_45ZLRPlm2_45GDzsdMkT05tYNluKcMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/identitas/[id].vue?macro=true";
import { default as _91id_93alYB2eFDWItOvFVXGw_45xuTKANpWjcUFUFiETPdJO2CgMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/peraturan/[id].vue?macro=true";
import { default as form0ntDxD3I0U_nQ_s7lNghryStfthM8neB0o2hxH7_45T2AMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/peraturan/form.vue?macro=true";
import { default as indexIu3_NTBmNGYbp4C3tJJCawB4eeK02JwCbdSyrxlT2pwMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/dashboard/index.vue?macro=true";
import { default as indexbI5hDZ5ou_45zDCrLIdp6_IF3et7Fqx9Ln3FbRsfcgeGAMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/halstatis/index.vue?macro=true";
import { default as indexwOH94V7qqw2oTgYy2rKcjP8UaV8aS_tsD9VP2RDd9BQMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/identitas/index.vue?macro=true";
import { default as _91id_93exSsQr6bf7EitcAWjLgDvqZMYoU0aPKrDzkGro1fd7oMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/instruktur/[id].vue?macro=true";
import { default as indexxNmDGfauhJO_bHfHrys7PEZafM80nV3Xy9C9PDcUdiAMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/peraturan/index.vue?macro=true";
import { default as _91id_93vSxnvzFN_BpDkOFYEalI8broTqXgH09OLcO6Oed_VywMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial/[id].vue?macro=true";
import { default as formAtC25lVHLdPLywFdH_eb2Xby8QGpcuvjPD6fEGQw4c0Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial/form.vue?macro=true";
import { default as indexEcuB9_45VSKxbtSKlLjbHqTEuEWSATJn1q8ywKVsbKjyYMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial/index.vue?macro=true";
import { default as _91id_93rBHWnJLRDXem5hrWi2i_45PlX8eJ_45uzodZgvp_2m8JmB8Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/google-adsense/[id].vue?macro=true";
import { default as formjb7UZHP8tnUinV3UwvRJsudw0rhnzkL1QTfEZHeaIVoMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/google-adsense/form.vue?macro=true";
import { default as _91id_93Ys3byzmRNVOV03A11fwBJ6mCbVivXNfF6Zl81OZosl8Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/materi-ecourse/[id].vue?macro=true";
import { default as formAIu3mQ5t7a6_45tTkhPU0da6fxH_45mBHHkc64CZ5oDxPm8Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/materi-ecourse/form.vue?macro=true";
import { default as indexbpDxSfwXtJ53ZZMvw6iFeJIDVXYTztQUN2GV4jc_pVoMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/google-adsense/index.vue?macro=true";
import { default as indexAHNjOEWX6I1_oKoJvkSbi5JI9lpwtYamD1t4OISy7P0Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/materi-ecourse/index.vue?macro=true";
import { default as _91id_93C27J_3Hsll_45GoJB2bQJPGIMsl_45Uxvl3CVJvUp45ciTgMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori_produks/[id].vue?macro=true";
import { default as formQsRnnIoDG1tEZiche1YnJkIx_45DhyGcrHQGC8zbR__45e0Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori_produks/form.vue?macro=true";
import { default as _91id_93lU_kwkv0yN4RdGU1lFjm8lZmMWTJFELwcglHTcV1f_45AMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori-ecourse/[id].vue?macro=true";
import { default as formlBauq6h10QIeG4v8s3Hc69paAsOukbkZ8_45J39DkxTMwMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori-ecourse/form.vue?macro=true";
import { default as index014X2rZSTluOu3N8zq6PVBeW5OyoNfHC5C6nPjSSFsMMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori_produks/index.vue?macro=true";
import { default as index0Y_45KZVEwhhot3hkdcB0rghjMsIWZrr_45vwkUsJ3yojIQMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori-ecourse/index.vue?macro=true";
import { default as _91id_93fEE2FfmIWPh_459nq6C9_kd8zbWfbx9dvz1Tq1wXCMqcEMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial-student/[id].vue?macro=true";
import { default as formQq5I27V1A6GXZm2G8JzCZXfopubnguW0PH7VAp2rtiAMeta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial-student/form.vue?macro=true";
import { default as indexX8exHbpo2lWt7jyyGcj125i3BmOFdW8gz7ehyY4AJv0Meta } from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial-student/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/logout.vue")
  },
  {
    name: "quiz-id",
    path: "/quiz/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/quiz/[id].vue")
  },
  {
    name: "quiz-form",
    path: "/quiz/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/quiz/form.vue")
  },
  {
    name: "menus-id",
    path: "/menus/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/menus/[id].vue")
  },
  {
    name: "menus-form",
    path: "/menus/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/menus/form.vue")
  },
  {
    name: "quiz",
    path: "/quiz",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/quiz/index.vue")
  },
  {
    name: "roles-id",
    path: "/roles/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/roles/[id].vue")
  },
  {
    name: "roles-form",
    path: "/roles/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/roles/form.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/users/[id].vue")
  },
  {
    name: "users-form",
    path: "/users/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/users/form.vue")
  },
  {
    name: "menus",
    path: "/menus",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/menus/index.vue")
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/roles/index.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/users/index.vue")
  },
  {
    name: "ecourse-id",
    path: "/ecourse/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/ecourse/[id].vue")
  },
  {
    name: "ecourse-form",
    path: "/ecourse/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/ecourse/form.vue")
  },
  {
    name: "pembeli-id",
    path: "/pembeli/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/pembeli/[id].vue")
  },
  {
    name: "produks-id",
    path: "/produks/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/produks/[id].vue")
  },
  {
    name: "produks-form",
    path: "/produks/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/produks/form.vue")
  },
  {
    name: "royalty-id",
    path: "/royalty/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/royalty/[id].vue")
  },
  {
    name: "student-id",
    path: "/student/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/student/[id].vue")
  },
  {
    name: "discount-id",
    path: "/discount/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/discount/[id].vue")
  },
  {
    name: "discount-form",
    path: "/discount/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/discount/form.vue")
  },
  {
    name: "ecourse",
    path: "/ecourse",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/ecourse/index.vue")
  },
  {
    name: "produks",
    path: "/produks",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/produks/index.vue")
  },
  {
    name: "discount",
    path: "/discount",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/discount/index.vue")
  },
  {
    name: "forgotpassword",
    path: "/forgotpassword",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/forgotpassword.vue")
  },
  {
    name: "halstatis-id",
    path: "/halstatis/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/halstatis/[id].vue")
  },
  {
    name: "halstatis-form",
    path: "/halstatis/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/halstatis/form.vue")
  },
  {
    name: "identitas-id",
    path: "/identitas/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/identitas/[id].vue")
  },
  {
    name: "peraturan-id",
    path: "/peraturan/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/peraturan/[id].vue")
  },
  {
    name: "peraturan-form",
    path: "/peraturan/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/peraturan/form.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/dashboard/index.vue")
  },
  {
    name: "halstatis",
    path: "/halstatis",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/halstatis/index.vue")
  },
  {
    name: "identitas",
    path: "/identitas",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/identitas/index.vue")
  },
  {
    name: "instruktur-id",
    path: "/instruktur/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/instruktur/[id].vue")
  },
  {
    name: "peraturan",
    path: "/peraturan",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/peraturan/index.vue")
  },
  {
    name: "testimonial-id",
    path: "/testimonial/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial/[id].vue")
  },
  {
    name: "testimonial-form",
    path: "/testimonial/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial/form.vue")
  },
  {
    name: "testimonial",
    path: "/testimonial",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial/index.vue")
  },
  {
    name: "google-adsense-id",
    path: "/google-adsense/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/google-adsense/[id].vue")
  },
  {
    name: "google-adsense-form",
    path: "/google-adsense/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/google-adsense/form.vue")
  },
  {
    name: "materi-ecourse-id",
    path: "/materi-ecourse/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/materi-ecourse/[id].vue")
  },
  {
    name: "materi-ecourse-form",
    path: "/materi-ecourse/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/materi-ecourse/form.vue")
  },
  {
    name: "google-adsense",
    path: "/google-adsense",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/google-adsense/index.vue")
  },
  {
    name: "materi-ecourse",
    path: "/materi-ecourse",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/materi-ecourse/index.vue")
  },
  {
    name: "kategori_produks-id",
    path: "/kategori_produks/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori_produks/[id].vue")
  },
  {
    name: "kategori_produks-form",
    path: "/kategori_produks/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori_produks/form.vue")
  },
  {
    name: "kategori-ecourse-id",
    path: "/kategori-ecourse/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori-ecourse/[id].vue")
  },
  {
    name: "kategori-ecourse-form",
    path: "/kategori-ecourse/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori-ecourse/form.vue")
  },
  {
    name: "kategori_produks",
    path: "/kategori_produks",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori_produks/index.vue")
  },
  {
    name: "kategori-ecourse",
    path: "/kategori-ecourse",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/kategori-ecourse/index.vue")
  },
  {
    name: "testimonial-student-id",
    path: "/testimonial-student/:id()",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial-student/[id].vue")
  },
  {
    name: "testimonial-student-form",
    path: "/testimonial-student/form",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial-student/form.vue")
  },
  {
    name: "testimonial-student",
    path: "/testimonial-student",
    component: () => import("D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/pages/testimonial-student/index.vue")
  }
]